import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function useAuthGuard() {
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem('access_token');
        if (!token) {
            navigate('/login');
        }
    }, [navigate]);
}

export default useAuthGuard;
